import gql from 'graphql-tag'

export const SamplesTableQuery = gql`
	query SamplesTableQuery {
		samples {
			_id
			name
			lastReviewDate
			hasReview
			team {
				_id
				path
				n
			}
			poolTags {
				musicConcept
				genres
				subgenres
				tags
				intensities
				langs
			}
		}
	}
`

export const SampleDetailsQuery = gql`
	query fetchSampleDetails($id: String!) {
		sampleById(_id: $id) {
			_id
			name
			teamId
			team {
				_id
				path
				n
			}
			description
			image
			tracks {
				trackId
				start
				end
			}
			trackObjects {
				_id
				title
				artist
				optimizedMono {
					duration
				}
				optimizedStereo {
					duration
				}
				artwork
				comment
			}
			playlist {
				_id
				n
				created
				path
				idPath
				a
			}
			playlistId
			updatedBy {
				date
				email
				name
			}
			createdBy {
				date
				email
				name
			}
			expirationDate
			reviews {
				_id
				comment
				tracks {
					trackId
					rating
					comment
					reason
				}
				createdBy {
					date
					email
					name
				}
				trackObjects {
					_id
					title
					artist
					artwork
				}
			}
			commentCount
			poolTags {
				musicConcept
				genres
				subgenres
				tags
				intensities
				langs
			}
		}
	}
`
